import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import { getInputField, getPasswordInputField } from '../subscriptor/forms/fields';
import { maintainerForm as styles } from '../maintainer/styles';
import { USER_MAX_LENGTH_PASSWORD, USER_MIN_LENGTH_PASSWORD } from '../../libraries/constants';

import {
  INCORRECT_MINIMUM_CHARACTERS_PASSWORD,
  CHANGE_PASSWORD_TITLE
} from '../../libraries/texts';

import { maximumSubString } from '../../libraries/utils';

const form = props => {
  const {
    values,
    classes,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = props;
  const {
    match: {
      params: { id }
    }
  } = props;

  const fieldProps = {
    handleBlur,
    classes,
    touched,
    errors,
    values,
    setFieldValue,
    setFieldError,
    setFieldTouched
  };

  return (
    <Card className={classes.card}>
      <CardHeader title={CHANGE_PASSWORD_TITLE} className={classes.cardTitle} />
      <CardContent className={classes.cardContent}>
        {values ? (
          <React.Fragment>
            {getInputField({
              ...fieldProps,
              name: `oldPassword`,
              label: 'Contraseña anterior',
              type: 'password',
              placeholder: '',
              required: true,
              changeHandler: maximumSubString(USER_MAX_LENGTH_PASSWORD),
              formControlClass: classes.fullWidth
            })}
            {getPasswordInputField({
              ...fieldProps,
              name: `password`,
              label: 'Contraseña',
              prefixLabel: !id ? '' : 'Nueva ',
              placeholder: INCORRECT_MINIMUM_CHARACTERS_PASSWORD(USER_MIN_LENGTH_PASSWORD),
              required: true,
              changeHandler: maximumSubString(USER_MAX_LENGTH_PASSWORD),
              formControlClass: classes.middleWidth
            })}
          </React.Fragment>
        ) : (
          ''
        )}
      </CardContent>
    </Card>
  );
};

form.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(form);
